import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { APP_BACKGROUND_COLOR, APP_COLOR } from "../../theme";

export const styles = {
  userDetailsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(5,1fr)",
    alignItems: "center",
    textAlign: "center",
    backgroundColor:APP_BACKGROUND_COLOR,
    color: "white",
    margin: "10px",
  } as const,
  button: {
    backgroundColor: APP_COLOR,
    margin: "10px",
    width: "100px",
  } as const,
  modalContainerStyles: {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    textAlign: "center",
  } as const,
};

export const UserTableContainer = styled(Box)(({ theme }) => ({
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  margin: "0px 50px 30px 50px",
  padding: "0.4rem 0.55rem 0.55rem 0.55rem",
  borderRadius: 5,
  backgroundColor:APP_BACKGROUND_COLOR,
  color: "white",
  [theme.breakpoints.down("md")]: {
    margin: "20px",
    padding: 0,
  },
  [theme.breakpoints.down("sm")]: {
    margin: "10px",
    padding: 0,
  },
}));
